import { render, staticRenderFns } from "./nursePresWay.vue?vue&type=template&id=88892884&scoped=true&"
import script from "./nursePresWay.vue?vue&type=script&lang=ts&"
export * from "./nursePresWay.vue?vue&type=script&lang=ts&"
import style0 from "./nursePresWay.vue?vue&type=style&index=0&id=88892884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88892884",
  null
  
)

export default component.exports